import { MdKeyboardArrowDown } from 'react-icons/md';
import type { MenuProps } from 'antd';
import { Button, Dropdown as AntdDropdown, Menu, Space } from 'antd';
import React from 'react';

interface NewDropdownProps {
  label?: string;
  name: string;
  items: { label: string; key: string | number }[];
  handleMenuClick?: MenuProps['onClick'];
  buttonType?: 'link' | 'text' | 'default' | 'primary' | 'dashed' | undefined;
  buttonTextStyle?: string;
}

export const NewDropdown: React.FC<NewDropdownProps> = ({
  name,
  items,
  label,
  handleMenuClick,
  buttonType = 'default',
  buttonTextStyle,
}) => {
  return (
    <Space wrap>
      <AntdDropdown overlay={<Menu onClick={handleMenuClick} items={items} />}>
        <Button type={buttonType}>
          <Space>
            <div className={buttonTextStyle}>{label}</div>
            <MdKeyboardArrowDown />
          </Space>
        </Button>
      </AntdDropdown>
    </Space>
  );
};
